import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import TypeForm from "./TypeForm";
const EditType = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Type_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Type"
  
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editTriggerType"
        ModalName="Edit_Type_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Type_Modal ? Edit_Type_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="typeList"
      >
        <TypeForm form={form} />
      </FormModal>
    </div>
  );
};

export default EditType;
